<template>
  <div>
    <div id="home"></div>
    <v-container class="screen3 actions">
      <!--
      <v-layout row wrap>
        <v-flex xs12 md4>
          <div class="actions-block">
            <v-img src="/static/img/actions/1.jpg" class="actions-img"></v-img>
          </div>
        </v-flex>
        <v-flex xs12 md8>
          <div class="actions-block">
            <h2>Пятый час в подарок</h2>
            <div>Если вы бронируете 4 часа, то пятый час вы получаете в подарок!</div>
          </div>
        </v-flex>
      </v-layout>
      -->
      <v-layout row wrap>
        <v-flex xs12 md4>
          <div class="actions-block">
            <v-img src="/static/img/actions/2.jpg" class="actions-img"></v-img>
          </div>
        </v-flex>
        <v-flex xs12 md8>
          <div class="actions-block">
            <h2>Скидка имениннику 10%</h2>
            <div>Если вы бронируете проведение своего дня рождения у нас, то получаете скидку 10%!</div>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <app-acropolis-reviews></app-acropolis-reviews>
    <app-acropolis-contacts></app-acropolis-contacts>
    <app-button-go-back :goto="goto"></app-button-go-back>

  </div>
</template>

<script>
export default {
  data () {
    return {
      goto: { path: '/acropolis' }
    }
  }
}
</script>

<style scoped>
.actions-block {
  margin: 15px;
}

.actions-img {
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
}

/* MEDIA */
/* EXTRA SMALL */
@media (max-width: 600px) {

}

</style>



// WEBPACK FOOTER //
// src/components/pages/acropolis/Actions.vue